// import { defaultDirection } from '../constants/config'


export const convertToArray = (list, prop) => {
  var newlist = [];

  for (var i = 0; i < list.length; i++) {
    newlist.push(list[i][prop]);
  }

  return newlist;
}

export const automapper = (list, keys) => {
  var newlist = [];
  for (let i = 0; i < list.length; i++) {
    var item = {};
    for (let j = 0; j < keys.length; j++) {
      if (list[0].hasOwnProperty(keys[j])) {
        item[keys[j]] = list[i][keys[j]];
      }

    }
    const it = Object.assign({}, item);
    newlist.push(it);
  }

  return newlist;

}

// export const mapOrder = (array, order, key) => {
//   array.sort(function (a, b) {
//     var A = a[key]
//     var B = b[key]
//     if (order.indexOf(A + '') > order.indexOf(B + '')) {
//       return 1
//     } else {
//       return -1
//     }
//   })
//   return array
// }

// export const getDateWithFormat = () => {
//   const today = new Date()
//   let dd = today.getDate()
//   let mm = today.getMonth() + 1 // January is 0!

//   var yyyy = today.getFullYear()
//   if (dd < 10) {
//     dd = '0' + dd
//   }
//   if (mm < 10) {
//     mm = '0' + mm
//   }
//   return dd + '.' + mm + '.' + yyyy
// }

// export const getCurrentTime = () => {
//   const now = new Date()
//   return now.getHours() + ':' + now.getMinutes()
// }

// export const ThemeColors = () => {
//   let rootStyle = getComputedStyle(document.body)
//   return {
//     themeColor1: rootStyle.getPropertyValue('--theme-color-1').trim(),
//     themeColor2: rootStyle.getPropertyValue('--theme-color-2').trim(),
//     themeColor3: rootStyle.getPropertyValue('--theme-color-3').trim(),
//     themeColor4: rootStyle.getPropertyValue('--theme-color-4').trim(),
//     themeColor5: rootStyle.getPropertyValue('--theme-color-5').trim(),
//     themeColor6: rootStyle.getPropertyValue('--theme-color-6').trim(),
//     themeColor1_10: rootStyle.getPropertyValue('--theme-color-1-10').trim(),
//     themeColor2_10: rootStyle.getPropertyValue('--theme-color-2-10').trim(),
//     themeColor3_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
//     themeColor4_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
//     themeColor5_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
//     themeColor6_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
//     primaryColor: rootStyle.getPropertyValue('--primary-color').trim(),
//     foregroundColor: rootStyle.getPropertyValue('--foreground-color').trim(),
//     separatorColor: rootStyle.getPropertyValue('--separator-color').trim()
//   }
// }

// export const getDirection = () => {
//   let direction = defaultDirection
//   if (localStorage.getItem('direction')) {
//     const localValue = localStorage.getItem('direction')
//     if (localValue === 'rtl' || localValue === 'ltr') {
//       direction = localValue
//     }
//   }
//   return {
//     direction,
//     isRtl: direction === 'rtl'
//   }
// }

// export const setDirection = localValue => {
//   let direction = 'ltr'
//   if (localValue === 'rtl' || localValue === 'ltr') {
//     direction = localValue
//   }
//   localStorage.setItem('direction', direction)
// }
